export default __webpack_public_path__ + "static/media/project_thumbnail_cathulhu.b542f61d.png";